import { useSystemSetting } from "@/api/services/admin/system-setting";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { SettingForm } from "@/features/system-settings/components/notification/SettingForm";
import { convertEmailSettingResToForm } from "@/features/system-settings/utils/converts";

const NotificationPage = () => {
  const { data, isLoading } = useSystemSetting();

  if (isLoading) return <LoadingPage />;

  const previousData = data?.data ? convertEmailSettingResToForm(data.data) : undefined;

  return <SettingForm previousData={previousData} />;
};

export default NotificationPage;
